import {axios as http} from "../frameworks_and_drivers/Axios"
import settings from "../config/settings.json";

const { BASE_URL, TOKEN, AGORA_SUBSCRIPTION_KEY } = settings;

const opts = {
    headers:{
        Authorization: `Bearer ${TOKEN}`,
        'Agora-Subscription-Key': AGORA_SUBSCRIPTION_KEY
    }

}

export const dewaltServicesGetAll = async (serviceCenterId = null) => {
    let URL = `${BASE_URL}/dewalt-services/get-all`;
    // Add service_center query parameter if provided
    if (serviceCenterId) {
        URL += `?service_center=${serviceCenterId}`;
    }
    
    const response = await http.get(URL, opts);
    return response;
}
export const getDewaltServicesById = async (objectId) => {

    const URL=`${BASE_URL}/dewalt-services/get-by-id/${objectId}`;
    const response = await http.get(URL,opts);
    return response;
}

export const getDewaltProductById = async (objectId) => {
    const URL=`${BASE_URL}/products/get-by-id/${objectId}`;
    const response = await http.get(URL,opts);
    return response;
}

export const getDewaltCategoryById = async (objectId) => {
    const URL=`${BASE_URL}/categories/get-by-id/${objectId}`;
    const response = await http.get(URL,opts);
    return response;
}
export const getDewaltSubCategoryById = async (objectId) => {
    const URL=`${BASE_URL}/subcategories/get-by-id/${objectId}`;
    const response = await http.get(URL,opts);
    return response;
}
export const dewaltServicesChangeStatus = async (objectId) => {
    const URL=`${BASE_URL}/dewalt-services/change-status/${objectId}`;
    const response = await http.put(URL,{},opts);
    return response;
}

export const dewaltServicesChangeStatusPending = async (objectId) => {
    const data = {status: "pending" }
    const URL=`${BASE_URL}/dewalt-services/change-status/${objectId}`;
    const response = await http.put(URL,data,opts);
    return response;
}

export const dewaltServicesVerifyWarranty = async (warranty,paid,objectId) => {
    const data = {has_warranty: warranty ,user_paid: paid};
    const URL=`${BASE_URL}/dewalt-services/verify-warranty/${objectId}`;
    const response = await http.put(URL,data,opts);
    return response;
}
export const LoginServiceCenter = async (email,password) => {
    const data = {email: email ,password: password};
    const URL=`${BASE_URL}/service-centers/login`;
    const response = await http.post(URL,data,opts);
    return response;
}


export const DHLService = async (guideNumber) => {
    const URL=`${BASE_URL}/dewalt-services/get-by-tracking/${guideNumber}`;
    const response = await http.post(URL,opts);
    return response;
}

export const downloadDewaltServiceInvoice = async (objectId) => {
    const URL = `${BASE_URL}/dewalt-services/download-invoice/${objectId}`;
    const response = await http.get(URL, {
        ...opts,
        responseType: 'blob' // Important for downloading files
    });
    return response;
}

export const downloadDewaltGuide = async (guideUrl) => {
    // Extract the path after amazonaws.com for the proxy endpoint
    if (!guideUrl) throw new Error('Guide URL is required');
    
    // Find the position after amazonaws.com
    const awsComIndex = guideUrl.indexOf('amazonaws.com');
    if (awsComIndex === -1) {
        throw new Error('Invalid AWS URL format');
    }
    
    // Extract the path after amazonaws.com
    const pathAfterAws = guideUrl.substring(awsComIndex + 'amazonaws.com'.length);
    
    // Use the proxy endpoint with authentication
    const URL = `${BASE_URL}/files${pathAfterAws}`;
    const response = await http.get(URL, {
        ...opts,
        responseType: 'blob' // Important for downloading files
    });
    return response;
}

// New proxy endpoint functions for files
export const getDewaltServiceFile = async (filePath) => {
    // Use the proxy endpoint with the file path
    const URL = `${BASE_URL}/files${filePath}`;
    const response = await http.get(URL, {
        ...opts,
        responseType: 'blob' // For images and files
    });
    return response;
}

export const getDewaltProductImageUrl = (imagePath) => {
    // Simply construct the URL for images using the proxy endpoint
    return `${BASE_URL}/files${imagePath}`;
}
